const getSrc = function (input) {
  if (typeof input !== 'string') {
    throw new TypeError('get-src expected a string')
  }
  const re = /src="(.*?)"/gm
  const url = re.exec(input)

  if (url && url.length >= 2) {
    return url[1]
  }
}

const getVideoId = function (str) {
  if (typeof str !== 'string') {
    throw new TypeError('get-video-id expects a string')
  }

  if (/<iframe/ig.test(str)) {
    str = getSrc(str)
  }

  str = str.trim()

  str = str.replace('-nocookie', '')

  str = str.replace('/www.', '/')

  let metadata = {}

  if (/\/\/google/.test(str)) {
    const matches = str.match(/url=([^&]+)&/)

    if (matches) {
      str = decodeURIComponent(matches[1])
    }
  }

  if (/youtube|youtu\.be|i.ytimg\./.test(str)) {
    metadata = {
      id: youtube(str),
      service: 'youtube'
    }
  } else if (/vimeo/.test(str)) {
    metadata = {
      id: vimeo(str),
      service: 'vimeo'
    }
  } else if (/bilibili/.test(str)) {
    metadata = {
      id: bilibili(str),
      service: 'bilibili'
    }
  }
  return metadata
}

function vimeo(str) {
  if (str.indexOf('#') > -1) {
    str = str.split('#')[0]
  }
  if (str.indexOf('?') > -1 && str.indexOf('clip_id=') === -1) {
    str = str.split('?')[0]
  }

  let id, arr

  if (/https?:\/\/vimeo\.com\/[0-9]+$|https?:\/\/player\.vimeo\.com\/video\/[0-9]+$|https?:\/\/vimeo\.com\/channels|groups|album/igm.test(str)) {
    arr = str.split('/')
    if (arr && arr.length) {
      id = arr.pop()
    }
  } else if (/clip_id=/igm.test(str)) {
    arr = str.split('clip_id=')
    if (arr && arr.length) {
      id = arr[1].split('&')[0]
    }
  }

  return id
}

function youtube(str) {
  const shortcode = /youtube:\/\/|https?:\/\/youtu\.be\//g

  if (shortcode.test(str)) {
    const shortcodeid = str.split(shortcode)[1]
    return stripParameters(shortcodeid)
  }

  const inlinev = /\/v\/|\/vi\//g

  if (inlinev.test(str)) {
    const inlineid = str.split(inlinev)[1]
    return stripParameters(inlineid)
  }

  const parameterv = /v=|vi=/g

  if (parameterv.test(str)) {
    const arr = str.split(parameterv)
    return arr[1].split('&')[0]
  }

  const parameterwebp = /\/an_webp\//g

  if (parameterwebp.test(str)) {
    const webp = str.split(parameterwebp)[1]
    return stripParameters(webp)
  }

  const embedreg = /\/embed\//g

  if (embedreg.test(str)) {
    const embedid = str.split(embedreg)[1]
    return stripParameters(embedid)
  }

  const userreg = /\/user\//g

  if (userreg.test(str)) {
    const elements = str.split('/')
    return stripParameters(elements.pop())
  }

  const attrreg = /\/attribution_link\?.*v%3D([^%&]*)(%26|&|$)/

  if (attrreg.test(str)) {
    return str.match(attrreg)[1]
  }
}
function bilibili(str) {
  const myStr = str + '/'
  const code = myStr.substring(
    myStr.lastIndexOf('/av') + 1,
    myStr.lastIndexOf('/')
  ).replace('av', '')
  return code
}
function stripParameters(str) {
  if (str.indexOf('?') > -1) {
    return str.split('?')[0]
  } else if (str.indexOf('/') > -1) {
    return str.split('/')[0]
  }
  return str
}

export default getVideoId
